import { TOGGLE_MODAL, ToggleModal } from './types'

export const toggleModal: ToggleModal = (modal) => {
  return {
    type: TOGGLE_MODAL,
    payload: modal
  }
}
